var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-tr",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f31930",
    d: "M0 0h512v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.772 263.97c0 70.63-58.247 127.883-130.1 127.883S88.572 334.6 88.572 263.97s58.247-127.88 130.1-127.88 130.1 57.254 130.1 127.88z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.28 263.965c0 56.5-46.6 102.304-104.08 102.304s-104.08-45.804-104.08-102.305 46.598-102.303 104.08-102.303 104.08 45.803 104.08 102.303z",
    fill: "#f31830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.104 204.23l-1.05 47.272-44.103 11.973 43.474 15.482-1.05 43.35 28.352-33.853 42.842 14.863-24.782-36.332 30.242-36.125-46.413 12.798-27.512-39.428z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/tr.4361a465facb5dc6e76b857b014cfec9.svg";
export { ForwardRef as ReactComponent };